import { render, staticRenderFns } from "./addComplieance.vue?vue&type=template&id=9bf6faba&"
import script from "./addComplieance.vue?vue&type=script&lang=js&"
export * from "./addComplieance.vue?vue&type=script&lang=js&"
import style0 from "./addComplieance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports